<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uMMaSk/tc-custom/9780253005199.jpg?1736619090941" alt="This image is the cover for the book Starring Madame Modjeska"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Starring Madame Modjeska
      </h1>
      <p class="bookDescription body article font2">
        <b>The “important . . . meticulously researched” prize-winning biography of the pre-eminent Polish star of the nineteenth century global stage (CosmopolinReview.com).</b><br/>  <br/> In reintroducing “a little-remembered actress to a new American audience” biographer Beth Holgram delivers a revelatory portrait of Helena Modjeska—from unparalleled European success to her reign as the most acclaimed, and most recognized female celebrity in the late nineteenth-century United States.<br/>  <br/> In 1876, Poland’s leading actress, Helena Modrzejewska, accompanied by her husband, the self-stylized Count Bozente, emigrated to southern California to give up her career and establish a utopian commune. In light of its failings, it hardly fulfilled the real dreams of Madame Helena. Within a year, she changed her surname to Modjeska, and made her American debut at San Francisco’s California Theatre. Godmother to Ethel Barrymore, and sharing the Shakespearian stage with such luminaries as Otis Skinner, Edwin Booth, and Maurice Barrymore, Helena Modjeska became <i>the</i> leading star in the United States, where she reigned for the next thirty years.<br/>  <br/> In this “Impressive . . . achievement,” Holmgren traces Modjeska’s fabulous life and career from her illegitimate birth in Krakow, to her successive reinventions of herself as a trans-continental diva, and finally to her enduring legacy (<i>Women’s Review of Books</i>). All in all, <i>Starring Madame Modjeska</i> “makes for great drama” (<i>NewPages.com</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Holmgren
      </h2>
      
      <p class="authorDescription body article">Beth Holmgren is Professor of Slavic and Eurasian Studies and Theater Studies at Duke University. She is author of Women's Works in Stalin's Time (IUP, 1993), editor (with Helena Goscilo) of Poles Apart: Women in Modern Polish Culture and Russia • Women • Culture (IUP, 1996), and translator and editor (with Helena Goscilo) of The Keys to Happiness by Anastasya Verbitskaya (IUP, 1999).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4f8ba06